import { render, staticRenderFns } from "./modal-create-responsible.vue?vue&type=template&id=635164dc"
import script from "./modal-create-responsible.vue?vue&type=script&lang=js"
export * from "./modal-create-responsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports